import { Immutable } from 'nuclear-js';

export default {
    // student should be a plain ol' JS object (not immmutable)
    // Output:  Last, First M. (if middle name exists)
    //          Last, First (if no middle name)
    formatStudentName: function(student) {
        if (!student || !student.lastName || !student.firstName) {
            return null;
        }

        let studentName = `${student.lastName}, ${student.firstName}`;
        if (student.middleName && student.middleName.length > 0) {
            studentName = `${studentName} ${student.middleName.substr(0, 1)}.`;
        }
        return studentName;
    },

    // Output when lastNameFirst: Last, First M.
    //                            Last, First (if no middle name)
    //
    // Output when !lastNameFirst: First M. Last (if middle name exists)
    //                             First Last (if no middle name)
    studentFullNameWithInitial: function(studentInfo, lastNameFirst = false) {
        if (!studentInfo) {
            return '';
        } else if (!(studentInfo instanceof Immutable.Map)) {
            throw new Error(
                'unexpected condition: item supplied should be a Map, but instead was ' + typeof studentInfo
            );
        } else {
            const first = studentInfo.get('firstName', '');
            const middle = studentInfo.get('middleName') ? studentInfo.get('middleName').substring(0, 1) + '.' : '';
            const last = studentInfo.get('lastName', '');

            if (lastNameFirst) {
                let name = first.length > 0 && last.length > 0 ? last : '';
                name = name.length > 0 && first.length > 0 ? name + ', ' + first : name;
                name = name.length > 0 && middle.length > 0 ? name + ' ' + middle : name;
                return name;
            } else {
                let name = first.length > 0 && last.length > 0 ? first : '';
                name = name.length > 0 && middle.length > 0 ? name + ' ' + middle : name;
                name = name.length > 0 && last.length > 0 ? name + ' ' + last : name;
                return name;
            }
        }
    },

    studentNameForFilename: function(studentInfo) {
        if (!studentInfo) {
            return 'student_name';
        } else if (!(studentInfo instanceof Immutable.Map)) {
            throw new Error(
                'unexpected condition: item supplied should be a Map, but instead was ' + typeof studentInfo
            );
        } else {
            const first = studentInfo.get('firstName') ? studentInfo.get('firstName') + '_' : '';
            const middle = studentInfo.get('middleName')
                ? studentInfo.get('middleName').substring(0, 1) + (studentInfo.get('lastName') ? '_' : '')
                : '';
            const last = studentInfo.get('lastName', '');
            const nameForFile = first + middle + last;
            return nameForFile ? nameForFile : 'student_name';
        }
    },
};
